import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import App from './App'
import { corporateTheme } from './theme/corporate'
import './index.css'

// 修复子路径部署时动态 import 相对路径解析错误
// Vite 5 生产构建会移除 import.meta.url，导致 import("./xxx.js") 相对于文档 URL 解析
// 直接设置正确的 base URL
const __viteBase = '/assets/'
// @ts-expect-error - 覆盖 Vite 的 __vite__mapDeps base
window.__viteBase = __viteBase

// dayjs 中文本地化：DatePicker 面板的星期/月份显示中文
dayjs.locale('zh-cn')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ConfigProvider locale={zhCN} theme={corporateTheme}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </StrictMode>,
)
